"use server";

import { auth } from "@/auth";
import { validateParams } from "@/lib/utils";
import z from "zod";
import type { ActionResult } from "@/types/server-action";
import { refreshDraftLock, releaseDraftLock } from "@/lib/cat/draft-lock";
import { prisma } from "@/prisma";

const heartbeatSchema = z.object({
  draftId: z.number().int().positive(),
});

export async function refreshDraftLockAction(
  params: z.infer<typeof heartbeatSchema>,
): Promise<ActionResult<{ refreshed: boolean }>> {
  try {
    const session = await auth();
    if (!session?.user?.id) {
      return { success: false, message: "Non authentifié." };
    }

    const { draftId } = validateParams(heartbeatSchema, params);
    const refreshed = await refreshDraftLock(draftId, session.user.id);
    if (refreshed) {
      await prisma.draft.update({
        where: { id: draftId },
        data: { lockedByUserId: session.user.id },
      });
    }

    return { success: true, data: { refreshed } };
  } catch (error) {
    console.error("[refreshDraftLockAction]", error);
    return { success: false, message: "Une erreur serveur est survenue." };
  }
}

export async function releaseDraftLockAction(
  params: z.infer<typeof heartbeatSchema>,
): Promise<ActionResult> {
  try {
    const session = await auth();
    const userId = session?.user?.id;
    const { draftId } = validateParams(heartbeatSchema, params);

    await releaseDraftLock(draftId, userId);
    await prisma.draft
      .update({
        where: { id: draftId },
        data: { lockedByUserId: null },
      })
      .catch(() => undefined);

    return { success: true };
  } catch (error) {
    console.error("[releaseDraftLockAction]", error);
    return { success: false, message: "Une erreur serveur est survenue." };
  }
}
